import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const getDashboardStats = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}dashboard/stats/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const getDashboardAPIVolume = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}dashboard/charts/api-volume`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const getDashboardEmailVolume = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}dashboard/charts/email-volume`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const getDashboardLogs = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}dashboard/logs/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

export {
  getDashboardStats,
  getDashboardAPIVolume,
  getDashboardEmailVolume,
  getDashboardLogs,
};
